import React from 'react';
import { OrderDetailsDTO } from '../../types/order';

interface ActivityCardProps {
  order: OrderDetailsDTO;
}

const ActivityCard: React.FC<ActivityCardProps> = ({ order }) => {
  if (order.audit.length === 0) {
    return (
      <div className="bg-white rounded-lg shadow p-6">
        <h3 className="text-lg font-semibold text-gray-900 mb-4">Activity & Audit</h3>
        <div className="text-center py-8 text-gray-500">
          <p>No activity recorded</p>
        </div>
      </div>
    );
  }
  
  return (
    <div className="bg-white rounded-lg shadow p-6">
      <h3 className="text-lg font-semibold text-gray-900 mb-4">Activity & Audit</h3>
      <div className="space-y-3">
        {order.audit.map((entry, index) => (
          <div key={index} className="border-l-2 border-gray-200 pl-4 py-2">
            <div className="flex justify-between items-start mb-1">
              <span className="font-medium text-gray-900">{entry.action}</span>
              <span className="text-xs text-gray-500">
                {new Date(entry.at).toLocaleString()}
              </span>
            </div>
            <p className="text-sm text-gray-600">by {entry.by}</p>
            {entry.payload && Object.keys(entry.payload).length > 0 && (
              <div className="mt-2 text-xs text-gray-500">
                {JSON.stringify(entry.payload, null, 2)}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ActivityCard;

